import { render, staticRenderFns } from "./InvestmentManagerDetail.vue?vue&type=template&id=56c3a430&scoped=true&"
import script from "./InvestmentManagerDetail.vue?vue&type=script&lang=js&"
export * from "./InvestmentManagerDetail.vue?vue&type=script&lang=js&"
import style0 from "./InvestmentManagerDetail.vue?vue&type=style&index=0&id=56c3a430&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c3a430",
  null
  
)

export default component.exports